import styled from '@emotion/styled'
import { css } from '@emotion/react'
import { Text } from '@leroy-merlin-br/backyard-react-ui'

const containerStyles = () => css`
  label: client;

  display: flex;

  align-items: center;
`

const thumbStyles = ({ theme }) => css`
  label: client__thumb;

  min-width: 54px;
  min-height: 54px;

  border-radius: ${theme.borderRadius.circle};
`

const titleStyles = ({ theme }) => css`
  color: ${theme.colors.n600};
`

const projectTitleStyles = ({ theme }) => css`
  label: client__project-title;

  font-size: ${theme.typography.subHeadings.mega.fontSize};
  color: ${theme.colors.p500};
  margin: 0;

  &::before {
    content: '';

    display: inline-block;
    vertical-align: baseline;

    width: 8px;
    height: 8px;

    border-radius: ${theme.borderRadius.circle};
    background: currentColor;
    margin-right: 10px;
  }
`

const projectContainerStyles = ({ theme }) => css`
  label: client__project-container;

  width: 54px;
  height: 54px;
  margin-right: ${theme.spacings.mega};
`

const photoImageStyles = ({ theme, avatar }) => css`
  label: client__photo-image;

  width: 100%;
  height: 100%;

  display: flex;
  align-items: center;
  justify-content: center;

  font-size: ${theme.typography.headings.tera.fontSize};
  line-height: ${theme.typography.headings.tera.lineHeight};
  color: ${theme.colors.n700};

  border-radius: ${theme.borderRadius.circle};

  background-color: ${theme.colors.n400};
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center center;

  ${avatar ? `background-image: url(${avatar});` : ''}

  box-shadow: 0 2px 6px rgba(84, 60, 158, 0.426437);

  ${theme.media.mega} {
    font-size: ${theme.typography.headings.exa.fontSize};
  }
`

export const Container = styled('div')(containerStyles)
export const Thumb = styled('img')(thumbStyles)
export const Title = styled(Text)(titleStyles)
export const ProjectTitle = styled('p')(projectTitleStyles)
export const PhotoContainer = styled('div')(projectContainerStyles)
export const PhotoImage = styled('div')(photoImageStyles)
